import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Spinner from "../components/Spinner";
//
const EditProduct = () => {
  const [local, setLocal] = useState("");
  const [priceInCents, setPriceInCents] = useState("");
  const [tags, setTags] = useState("");
  const [evento, setEvento] = useState("");
  const [loading, setLoading] = useState(false);
  const [atletas, setAtletas] = useState([]);
  const [filteredAtletas, setFilteredAtletas] = useState([]);
  const [selectedAtleta, setSelectedAtleta] = useState(null); // Novo estado para armazenar a atleta selecionada
  const [searchTerm, setSearchTerm] = useState(""); // Para armazenar o termo de busca do atleta
  const [image, setImage] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  // Função para buscar atletas
  useEffect(() => {
    const fetchAtletas = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`,
          config
        );
        setAtletas(response.data.data); // Armazenar todos os atletas
        setFilteredAtletas(response.data.data); // Inicializar a lista filtrada com todos os atletas
      } catch (error) {
        console.error("Erro ao buscar atletas:", error);
      }
    };
    fetchAtletas();
  }, []);

  // Buscar e preencher os dados do produto
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`)
      .then((response) => {
        setImage(response.data.imageSample); //imagem
        setLocal(response.data.local);
        setPriceInCents(response.data.priceInCents);
        setTags(response.data.tags);
        setEvento(response.data.evento);
        setSelectedAtleta({
          _id: response.data.atletaId, // Preencher com o ID da atleta do produto
          nome: response.data.atletaNome, // Preencher com o nome da atleta do produto
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        alert("An error happened. Check console");
      });
  }, [id]);

  // Função de busca dos atletas
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);

    // Filtra os atletas com base no nome
    const filtered = atletas
      .filter((atleta) => atleta.nome.toLowerCase().includes(query))
      .sort((a, b) => a.nome.localeCompare(b.nome));

    setFilteredAtletas(filtered);
  };

  // Função para selecionar um atleta
  const handleSelectAtleta = (event) => {
    const selectedId = event.target.value;

    // Se a opção "Selecione uma atleta" for escolhida, definimos selectedAtleta como ""
    if (selectedId === "") {
      setSelectedAtleta(""); // Aqui definimos selectedAtleta como uma string vazia
    } else {
      const selectedAtleta = atletas.find(
        (atleta) => atleta._id === selectedId
      );
      setSelectedAtleta(selectedAtleta); // Atualiza o estado com o objeto completo da atleta
    }
  };

  // Função para editar o produto
  const handleEditProduct = () => {
    const data = {
      local,
      priceInCents,
      tags,
      evento,
      atletaId: selectedAtleta ? selectedAtleta._id : "", // Se selectedAtleta for vazio, envia ""
      atletaNome: selectedAtleta ? selectedAtleta.nome : "", // Se selectedAtleta for vazio, envia ""
    };
    setLoading(true);
    axios
      .put(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`,
        data,
        config
      )
      .then(() => {
        setLoading(false);
        enqueueSnackbar("Produto atualizado.", { variant: "success" });
        navigate("/admin");
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar("Não foi possível atualizar", { variant: "error" });
        console.log(error);
      });
  };

  return (
    <div className="p-6 bg-base-100 grid lg:space-x-4 justify-center items-start mt-16 lg:flex">
      {loading && <Spinner />}
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-200">
        <Link
          to="/admin"
          className="flex justify-center items-center btn mb-4 w-12 py-2 px-4 text-sm rounded-xl"
        >
          Voltar
        </Link>
        <h1 className="text-3xl font-semibold my-4 ">Editar Produto</h1>
        <div className="my-4">
          <label htmlFor="local" className="block text-md mb-2">
            Local
          </label>
          <input
            id="local"
            type="text"
            value={local}
            onChange={(e) => setLocal(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="priceInCents" className="block text-md mb-2">
            Preço em centavos
          </label>
          <input
            id="priceInCents"
            type="number"
            value={priceInCents}
            onChange={(e) => setPriceInCents(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="tags" className="block text-md mb-2">
            Tags
          </label>
          <input
            id="tags"
            type="text"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <label htmlFor="evento" className="block text-lg mb-2 mt-4">
            Evento
          </label>
          <input
            id="evento"
            type="text"
            value={evento}
            onChange={(e) => setEvento(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          {/* Campo de seleção de Atleta com filtro */}
          <label htmlFor="atleta" className="block text-lg mb-2 mt-4">
            Atleta
          </label>
          <input
            id="atleta"
            type="text"
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Digite o nome do atleta"
            className="border px-4 py-2 w-full mb-2"
          />
          <select
            id="atleta-select"
            value={selectedAtleta?._id || ""}
            onChange={handleSelectAtleta}
            className="border px-4 py-2 w-full"
          >
            <option value="">Selecione uma atleta</option>
            {filteredAtletas.length > 0 ? (
              filteredAtletas.map((atleta) => (
                <option key={atleta._id} value={atleta._id}>
                  {atleta.nome}
                </option>
              ))
            ) : (
              <option disabled>Não há atletas correspondentes</option>
            )}
          </select>

          <button
            onClick={handleEditProduct}
            className="w-full bg-green-500 hover:bg-green-800 text-white py-2 px-4 rounded-md mt-4"
          >
            Save Changes
          </button>
        </div>
      </div>

      {/* Aqui está a div para a imagem, abaixo do formulário */}
      <div className="container items-center max-w-lg shadow-lg rounded-lg p-5 bg-base-200 mt-4">
        <div className="avatar">
          <div className="w-[480px] h-[480px] ali">
            <img src={image} alt="Miniatura do Produto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
